// product page accordions

$('.cst-img-accord .toggle').click(function() {
  	let $this = $(this);
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
});


// custom quantity button

$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-selector').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-selector').val(qty);
}); 

// review section slider

 $('.reviews_data').slick({
    autoplay: false,
    centerMode: true,
    centerPadding: '210px',
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        centerPadding: '30px',
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerPadding: '20px',
      }
    } 
    ]  
  });


$(document).on("click",'.bold_option_swatch input[type="checkbox"]' ,function() {
    setTimeout(function(){
        let price = $('.bold_option_total span').text();
        if(price){
            var amountWithoutDollar = price.replace('$', '');
            var amountInCents = parseFloat(amountWithoutDollar) * 100;
            let variant_price = $('.custom-price').data('variant_price');
            let checked_var = $('.swatch input[type="radio"]:checked').data('var_price');
            let total_price = amountInCents + checked_var;
            let format_price = Shopify.formatMoney(total_price)
            $('.custom-price').text(format_price);
        }else{
             let checked_var = $('.swatch input[type="radio"]:checked').data('var_price');
             let format_price = Shopify.formatMoney(checked_var)
             $('.custom-price').text(format_price);
        }
       
    },100)
});

$('.swatch input[type="radio"]:checked').parent().addClass('active');
$('.swatch input[type="radio"]').change(function(){
  $('.swatch-element').removeClass('active');
    $(this).parent().addClass('active');
    let price =  $(this).data('price');
    let cent_price =  $(this).data('var_price');
    let optionName =  $('.option-price .custom-price').text(price);
    let additonalprice =  $('.option-price .custom-price').attr('data-variant_price',cent_price);
    let changed_price = $('.bold_option_total span').text();
    if(changed_price){
      let amountWithoutDollars = changed_price.replace('$', '');
      let amountInCent = parseFloat(amountWithoutDollars) * 100;
      let total_prices = amountInCent + cent_price;
      let format_prices = Shopify.formatMoney(total_prices)
      $('.custom-price').text(format_prices);
    }else{
         let variant_prices = $('.custom-price').data('variant_price');
         let format_prices = Shopify.formatMoney(cent_price)
         $('.custom-price').text(format_prices);
    }

});


// video image section
$(document).ready(function(){
  $('.video-slider').slick({
    autoplay: false,
    centerMode: true,
    centerPadding: '220px',
    variableWidth:true,
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: '40px',
      }
    } 
    ]  
  });

  // Function to pause and reset a video
  function resetVideo(video) {
    if (video) {
      video.currentTime = 0;
      video.pause();
    }
  }

  // Function to toggle play and pause buttons
  function toggleButtons(container, showPlay) {
    container.find('.play-btn').toggle(showPlay);
    container.find('.pause-btn').toggle(!showPlay);
  }

  // Play button event
  $(document).on('click', '.play-btn', function(){
    var video = $(this).siblings('.video-container').find('video')[0];
    resetVideo(video);  // Reset the video
    video.play();
    toggleButtons($(this).closest('.video-slide'), false);
  });

  // Pause button event
  $(document).on('click', '.pause-btn', function(){
    var video = $(this).siblings('.video-container').find('video')[0];
    video.pause();
    toggleButtons($(this).closest('.video-slide'), true);
  });

  // Handle slide change
  $('.video-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var currentSlideElement = $(slick.$slides[currentSlide]);
    var nextSlideElement = $(slick.$slides[nextSlide]);
    var currentVideo = currentSlideElement.find('video')[0];
    var nextVideo = nextSlideElement.find('video')[0];

    resetVideo(currentVideo);  
    toggleButtons(currentSlideElement, true); 

    resetVideo(nextVideo); 
    toggleButtons(nextSlideElement, true); 
  });

  // Handle video end
  $(document).on('ended', '.video', function(){
    var videoContainer = $(this).closest('.video-slide');
    toggleButtons(videoContainer, true);
  });
});

$(".video-slide").hover(function () {
  $(this).addClass('hoverOn');
 
}, 
function () {
  $(this).removeClass('hoverOn');
    
});
